import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getSpendPerWorkerTimeseriesCsv } from 'api/pulse/spendPerWorkerTimeseries'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useSpendPerWorkerTimeseriesDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_spend_per_worker_timeseries', {
        filters: query,
      })
      const data = await getSpendPerWorkerTimeseriesCsv(query)
      fileDownload(data, 'spend_per_worker_timeseries.csv')
    },
  })
}
